import Vue from 'vue';
import Vuex from 'vuex';
import persistedState from 'vuex-persistedstate';
import * as modules from './modules';

Vue.use(Vuex);

const state = {
  loading: 0,
  error: null,
  contractInfo: {}, // 续约信息
};

const actions = {};

const mutations = {
  loadingStart(state) {
    state.loading = true;
  },
  loadingEnd(state) {
    state.loading = false;
  },
  reportError(state, error) {
    state.error = error;
  },
  updateContractInfo(state, payload) {
    state.contractInfo = {
      ...state.contractInfo,
      ...payload,
    };
  },
  clearContractInfo(state) {
    state.contractInfo = {};
  },
};

const store = new Vuex.Store({
  state,
  actions,
  mutations,
  modules,
  plugins: [
    persistedState(),
    // (store) => {
    //   store.subscribeAction({
    //     before: ({ payload = {} }) => {
    //       if (!payload.noLoading) {
    //         store.commit('loadingStart');
    //       }
    //     },
    //     after: ({ payload = {} }) => {
    //       debugger
    //       if (!payload.noLoading) {
    //         store.commit('loadingEnd');
    //       }
    //     },
    //   });
    // },
  ],
});

// 重置部分值
store.commit('user/updateMaxLoginTimes', 99);

const { dispatch: oldDispatch } = store;
const reportErrorDuringAction = (err) => {
  store.commit('reportError', err);
  store.commit('loadingEnd');
};
store.dispatch = (typeOrAction, payloadOrOptions, optionsArg) => {
  let returnVal;
  let type;
  let payload;
  let options;
  const firstArgType = typeof typeOrAction;

  if (firstArgType === 'string') {
    type = typeOrAction;
    payload = payloadOrOptions;
    options = optionsArg;
  } else if (firstArgType === 'object') {
    ({
      type,
      ...payload
    } = typeOrAction);
    options = payloadOrOptions;
  } else {
    throw new Error('invalid dispatch arguments');
  }

  try {
    returnVal = oldDispatch(type, payload, options);
  
    if (returnVal && returnVal.then) {
      returnVal = returnVal.catch((e) => {
        reportErrorDuringAction(e);

        // * 表示是否要在出错时让dispatch继续抛出错误以便在程序发起dispatch处catch到错误并进行处理
        // * 比如说根据dispatch返回的promise的resolve/reject状态选择是否关闭业务对话框
        // * 为了不增加不必要的复杂度，暂时不默认捕获promise抛出的错误，只进行错误报告
        // if (payload && !!payload._dontCatch) {
        //   throw e;
        // }

        throw e;
      });
    }
  } catch (e) {
    reportErrorDuringAction(e);
  }

  return returnVal;
};

export default store;
